import { render, staticRenderFns } from "./FreelancerThreads.vue?vue&type=template&id=f632370e&"
import script from "./FreelancerThreads.vue?vue&type=script&lang=js&"
export * from "./FreelancerThreads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports